
  import { LMap, LTileLayer, LPolygon, LPopup } from "vue2-leaflet";
  import "leaflet/dist/leaflet.css";
  
  export default {
    name: "MapView",
    components: {
      LMap,
      LTileLayer,
      LPolygon,
      LPopup,
    },
    data() {
      return {
        zoom: 10,
        center: [-4.1291667, 122.4125], // Center on Konawe Selatan
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution: "© OpenStreetMap contributors",
        districts: [
          {
            name: "Andoolo",
            color: "#1E88E5",
            coordinates: [
              [-4.100, 122.300],
              [-4.110, 122.320],
              [-4.120, 122.310],
              [-4.115, 122.290],
            ],
          },
          {
            name: "Benua",
            color: "#42A5F5",
            coordinates: [
              [-4.105, 122.350],
              [-4.115, 122.360],
              [-4.125, 122.340],
              [-4.110, 122.330],
            ],
          },
          {
            name: "Konda",
            color: "#5C6BC0",
            coordinates: [
              [-4.110, 122.300],
              [-4.120, 122.310],
              [-4.130, 122.290],
              [-4.115, 122.280],
            ],
          },
          // Add the remaining 22 kecamatan with unique colors and coordinates
        ],
      };
    },
  };
  